import { render, staticRenderFns } from "./BlogPostsTags.vue?vue&type=template&id=aabea0ba&"
import script from "./BlogPostsTags.vue?vue&type=script&lang=js&"
export * from "./BlogPostsTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports